import React from 'react';
import { Settings, Users, Trophy, BarChart2, MessageCircle, Calendar, Star } from 'lucide-react';
import { getHomeData, onClickButton } from '../logic/homeLogic';
import { onEnterNode } from '../logic/progressLogic';
import BottomNav from './BottomNav';
import { ASSETS } from '../assetManifest';

const goldGradient = 'linear-gradient(180deg, #FFB787 0%, #FFD24F 100%)';
const purpleBlueGradient = 'linear-gradient(180deg, #8161F6 0%, #40B8F4 100%)';
const grayGradient = 'linear-gradient(180deg, #C6C6C4 0%, #939393 99.58%)';

function Home({ app }) {
  const homeData = getHomeData(app);
  const featuredBanner = homeData.featuredBanner;

  return (
    <div className="min-h-screen flex flex-col justify-between text-white overflow-y-auto scrollbar-thin scrollbar-thumb-blue-900 scrollbar-track-black relative"
      style={{
        backgroundImage: `url(${ASSETS.backgrounds.home.path})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >

      {/* Right Navigation Buttons */}
      <div className="absolute top-4 right-4 flex flex-col items-center gap-6 z-10">
        {homeData.rightButtons.map((button, index) => (
          <button key={index} onClick={() => onClickButton(button.id, app, button.notification)} className="flex flex-col items-center gap-2 relative group">
            <div className="p-3 rounded-xl border border-[#2F4B58] shadow-lg transition-all duration-300 group-hover:scale-105" style={{ background: grayGradient }}>
              <button.icon size={40} className="text-white group-hover:text-white transition-colors duration-300 relative z-10 drop-shadow" />
            </div>
            <span className="text-sm text-white font-medium mt-2 tracking-wider opacity-80 group-hover:opacity-100 transition-opacity duration-300">
              {button.label}
            </span>
          </button>
        ))}
      </div>

      {/* Middle Content */}
      <div className="flex-grow flex flex-col items-center justify-center px-4">
        <span className="text-2xl font-cinzel font-bold text-white uppercase text-center mb-8 tracking-widest drop-shadow">
          {homeData.currentCampaign ? `${homeData.currentCampaign.levelNumber}. ${homeData.currentCampaign.name}` : 'INITIALIZING...'}
        </span>

        {/* Campaign Image */}
        <div className="w-[298px] h-[190px] rounded-lg overflow-hidden mb-4 border border-[#979797] bg-[#D8D8D8] relative">
          {homeData.currentCampaign?.image && (
            <img src={homeData.currentCampaign.image.path} alt="Campaign" className="w-full h-full object-cover" />
          )}
        </div>

        {/* Start Button */}
        <button onClick={() => homeData.currentCampaign && onEnterNode(app, homeData.currentCampaign.node)}
          className="relative w-[229px] h-[70px] text-xl font-bold uppercase rounded-xl border border-[#2F4B58] text-white transition-colors duration-200 tracking-widest overflow-hidden"
          style={{ background: goldGradient }}>
          <span className="relative z-10">LAUNCH</span>
        </button>
      </div>

      {/* Bottom Navigation Buttons */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-evenly items-center px-4 z-10">
        {homeData.leftButtons.map((button, index) => (
          <button key={index} className="flex flex-col items-center gap-2 relative group" onClick={() => onClickButton(button.id, app, button.notification)}>
            <div className="relative w-[70px] h-[70px] rounded-xl border border-[#2F4B58] flex items-center justify-center" style={{ background: purpleBlueGradient }}>
              {button.imagePath ? (
                <div className="w-10 h-10 rounded-full overflow-hidden relative z-10">
                  <img src={button.imagePath} alt={button.label} className="w-full h-full object-cover" />
                </div>
              ) : (
                <button.icon size={40} className="text-white relative z-10" fill="currentColor" />
              )}
            </div>
            <span className="text-sm text-white font-medium mt-2 tracking-wider opacity-80 group-hover:opacity-100 transition-opacity duration-300">
              {button.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Home;
